import _ from 'lodash';
import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { tickets } from '../../../../../../redux/tickets/action';
import { departments } from '../../../../../../redux/departments/action';
import { selectTicketsQueryItems, selectTicketsUpdatedItem } from '../../../../../../redux/tickets/selector';
import { useNavigate, useParams } from 'react-router-dom';
import { TicketComponent } from '../components/ticket.component';
import { ticketActivities } from '../../../../../../redux/ticket-activities/action';
import { selectEmployeesListItems } from '../../../../../../redux/employees/selector';
import { employees } from '../../../../../../redux/employees/action';
import PageLoader from '../../../../../../components/PageLoader';
import { selectDepartmentsListItems } from '../../../../../../redux/departments/selector';
import { deepCopy } from '../../../../../../common/services/common.service';
import storePersist from '../../../../../../redux/storePersist';
import { accountTypes } from '../../../../../../redux/account-types/action';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { selectAccountTypesListItems } from '../../../../../../redux/account-types/selector';
import { accounts } from '../../../../../../redux/accounts/action';

let currentChange: any = {}
function ManagementTicket() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const parmas: any = useParams();
  const libraryData = useSelector(selectListItems)
  const accountItems = useSelector(selectAccountsListItems)
  const accountTypeItems = useSelector(selectAccountTypesListItems)
  const TypeData = libraryData?.result?.Type
  const employeeLists = useSelector(selectEmployeesListItems)
  const departmentsLists = useSelector(selectDepartmentsListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const ticketQuery = useSelector(selectTicketsQueryItems)
  const [currentTicketId, setCurrentTicketId] = useState<any>();
  const userInfo = storePersist?.get("userProfile")?.current?.items
  const [isTickectActivities, setIsTickectActivities] = useState<boolean>(false)
  const [
    selectedActivities,
    setSelectedActivities
  ] = useState<any>([])
  const [
    selectedTicket,
    setSelectedTicket
  ] = useState<any>({});
  const [
    timeline,
    setTimeline
  ] = useState<any>([])

  const fetchTicketQueryById = async () => {
    await dispatch(tickets.query({
      url: `https://igm.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/service/cma/management/tickets/query`, entity: 'cma', jsonData:
      {

        "Records": [
          {
            "Context": {},
            "Message": {
              "Id": parmas?.id
            }
          }
        ]
      }

    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  useEffect(
    () => {

      if (isQuery) {
        setSelectedTicket(ticketQuery?.result?.items?.Message)
        const currentSelectedActivities = addNewRow({ selectedActivitiesArg: ticketQuery?.result?.items?.Message?.TicketActivities });
        setSelectedActivities(currentSelectedActivities)
        setTimeline(ticketQuery?.result?.items?.Message?.TicketActivities)
      }
    },
    [isQuery]
  )
  const handleFormActivityItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedActivities);// deep copy of activity items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setSelectedActivities(items);
  }

  const currentDateTime = moment();
  const minutesToSubtract = 1;
  const newDateTime = currentDateTime.clone().subtract(
    minutesToSubtract,
    'minutes'
  );
  const addNewRow = ({ selectedActivitiesArg }: any) => {
    const localSelectedActivities = deepCopy(selectedActivitiesArg)
    const newsSelectedActivitiesRecord = {
      Id: 0,
      TicketActivityTypeId: 0,
      Description: '',
      Subject: '',
      ActivityStatusId: 0,
      CascadedAccountTypeId: 0,
      CascadedAccountId: 0,
      IsResponse: true,
      IsVisibleToRequestor: true,
      StartTimeOnUtc: newDateTime.format('YYYY-MM-DDTHH:mm:ss'),
      StopTimeOnUtc: currentDateTime.format('YYYY-MM-DDTHH:mm:ss'),
      Email: '',
      PersonName: '',
      OrgName: '',
      ActionTypeId: 0,
      RefundAmount: 0,
      MediaMappings: {
        MediaFiles: []
      }
    }
    if (localSelectedActivities.length === 0 ||
      localSelectedActivities[localSelectedActivities?.length - 1]?.TicketActivityTypeId !== 0
    ) {
      localSelectedActivities?.push(newsSelectedActivitiesRecord)
    }

    return localSelectedActivities
  }
  const setCombinationInfo = async () => {
    let localSelectedActivities = deepCopy(selectedActivities)
    localSelectedActivities.splice(
      currentChange.idx,
      1,
      { ...localSelectedActivities[currentChange.idx] }
    );
    localSelectedActivities = addNewRow({ selectedActivitiesArg: localSelectedActivities });
    currentChange.field = 'TicketActivityTypeIdDONE'
    setSelectedActivities(localSelectedActivities)
  }

  const handleFormChange: any = ({ field, value }: any) => {
    currentChange = { value, field }
    setSelectedTicket({ ...selectedTicket, [field]: value })
  }
  const back = () => {
    navigate('/management/service/cma/tickets');
  }
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const ticketData = {
      "Context": {},
      "Message": {
        "Id": selectedTicket?.Id || 0,
        "AssociatedAccountId": selectedTicket?.AssociatedAccountId || 0,
        "AssociatedAccountTypeId": selectedTicket?.AssociatedAccountTypeId || 0,
        "ServiceRequestId": selectedTicket?.ServiceRequestId || 0,
        "TicketTypeId": selectedTicket?.TicketTypeId || 0,
        "TicketPriorityId": selectedTicket?.TicketPriorityId || 0,
        "RequestorName": selectedTicket?.RequestorName || '',
        "RequestorEmailId": selectedTicket?.RequestorEmailId || 0,
        "RequestorPhoneNo": selectedTicket?.RequestorPhoneNo || '',
        "Subject": selectedTicket?.Subject || '',
        "Description": selectedTicket?.Description || '',
        "Summary": selectedTicket?.Summary || '',
        "Notes": selectedTicket?.Notes || '',
        "TicketStatusId": selectedTicket?.TicketStatusId || 0,
        "DepartmentId": selectedTicket?.DepartmentId || 0,
        "EmployeeId": selectedTicket?.EmployeeId || 0,
        "DueDateOnUtc": selectedTicket?.DueDateOnUtc || '',
        "IsResolved": selectedTicket?.IsResolved || false,
        "ResolvedDescription": selectedTicket?.ResolvedDescription || '',
        "ResolvedById": selectedTicket?.ResolvedById || 0,
        "ResolvedOnUtc": selectedTicket?.ResolvedOnUtc || '',
        "IsClosed": selectedTicket?.IsClosed || false,
        "ClosedDescription": selectedTicket?.ClosedDescription || '',
        "ClosedById": selectedTicket?.ClosedById || 0,
        "ClosedOnUtc": selectedTicket?.ClosedOnUtc || '',
        "ParentTicketId": selectedTicket?.ParentTicketId || 0,
        "MediaMappings": {
          "MediaFiles": []
        }
      }
    }
    if (parmas?.id > 0) {
      dispatch(tickets.update({
        url: `https://igm.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/service/cma/management/tickets`, entity: 'tickets', jsonData: {

          "Records": [ticketData]

        }
      }))
        .then(() => {

          setCurrentTicketId(parmas?.id);
          setIsTickectActivities(true)

        })
    } else {
      dispatch(tickets.create({
        url: `https://igm.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/service/cma/management/tickets`, entity: 'tickets', jsonData: {

          Records: [ticketData]

        }
      }))
        .then(() => {
          back()
        })
    }
  }
  const updateTicketActivities = async () => {
    const localSelectedActivitiesData: any = R.map(R.assoc(
      'TicketId',
      currentTicketId
    ))(selectedActivities)

    localSelectedActivitiesData.splice(
      localSelectedActivitiesData.length - 1,
      1
    )

    const ticketActivity: any = localSelectedActivitiesData.map((item: any) => {
      const itemData = {
        Context: {},
        Message: {
          Id: item?.Id || 0,
          TicketId: item?.TicketId,
          TicketActivityTypeId: item?.TicketActivityTypeId,
          ServiceRequestId: selectedTicket?.ServiceRequestId || 0, // TO BE CHANGED. NEED TO CREATE A SR AND USE THE ID HERE.
          CascadedAccountTypeId: item?.CascadedAccountTypeId || 0,
          CascadedAccountId: item?.CascadedAccountId || 0,
          Description: item?.Description,
          Subject: item?.Subject || selectedTicket?.opennetworkTicketStatus?.message?.issue?.id || 'No Subject',
          StartTimeOnUtc: item?.StartTimeOnUtc,
          StopTimeOnUtc: item?.StopTimeOnUtc,
          ActivityStatusId: item?.ActivityStatusId,
          Phone: userInfo[0]?.PhoneNumber,
          IsResponse: item?.IsResponse,
          IsVisibleToRequestor: item?.IsVisibleToRequestor,
          Email: userInfo[0]?.Email,
          PersonName: userInfo[0]?.FirstName,
          OrgName: item?.OrgName,
          ActionTypeId: item?.ActionTypeId,
          RefundAmount: item?.RefundAmount
        }
      }

      return itemData
    })
    await dispatch(ticketActivities.update({
      url: `https://igm.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/service/cma/management/tickets/activities`, entity: 'activities', jsonData:
      {
        Records: ticketActivity
      }
    }))
    await setIsTickectActivities(false)
    await back()
  }
  useEffect(() => {
    if (selectedTicket?.AssociatedAccountTypeId) {
      const accountTypeName = accountTypeItems?.result?.items.find(
        (item: any) => item.Id === selectedTicket.AssociatedAccountTypeId
      )?.Name;
      const accountTypeValue = TypeData.find(
        (type: any) => type.Text === accountTypeName
      )?.Text;
      dispatch(accounts.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
        entity: 'accounts',
        jsonData: {
          "Filters": [
            {
              "FieldName": "Type",
              "FilterOperatorId": 6,
              "FieldValue": accountTypeValue,
              "FieldType": "text"
            }
          ],
        }
      }))
    }
  }, [selectedTicket?.AssociatedAccountTypeId]);
  useEffect(() => {
    if (selectedActivities?.length) {
      selectedActivities.map((activity: any) => {
        const accountTypeName = accountTypeItems?.result?.items.find(
          (item: any) => item.Id === activity.CascadedAccountTypeId
        )?.Name;
        const accountTypeValue = TypeData.find(
          (type: any) => type.Text === accountTypeName
        )?.Text;

        dispatch(accounts.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
          entity: 'accounts',
          jsonData: {
            "Filters": [
              {
                "FieldName": "Type",
                "FilterOperatorId": 6,
                "FieldValue": accountTypeValue,
                "FieldType": "text"
              }
            ],
          }
        }));
      });
    }
  }, [selectedActivities]);

  useEffect(
    () => {

      if (isTickectActivities) {
        updateTicketActivities()
      }
    },
    [isTickectActivities])
  useEffect(
    () => {
      dispatch(employees.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/employees/list`, entity: 'employees', jsonData: {}

      })).then(() => {
        dispatch(accountTypes.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
          entity: 'accountTypes',
          jsonData: {}
        }))
      })
        .then(() => {
          dispatch(departments.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/departments/list`, entity: 'departments', jsonData:
            {
              "Records": [
                {
                  "Id": 0
                }
              ]
            }
          }));
        }).then(() => {
          if (parmas?.id > 0) {
            fetchTicketQueryById()
            setIsLoading(false)
          } else {
            const localSelectedActivities = addNewRow({ selectedActivitiesArg: selectedActivities });
            setSelectedActivities(localSelectedActivities)
            setIsLoading(false)
          }
        })
    },
    []
  )
  useEffect(
    () => {
      if (currentChange.field === 'TicketActivityTypeId') {
        setCombinationInfo()
      }
    },
    [selectedActivities]
  )

  return (
    <>
      {isLoading ? <PageLoader /> :
        <TicketComponent
          departments={departmentsLists?.result?.items}
          employees={employeeLists?.result?.items}
          back={back}
          id={parmas?.id}
          selectedActivities={selectedActivities}
          onFormActivityItemChange={handleFormActivityItemChange}
          onFormChange={handleFormChange}
          handleFormSubmit={handleFormSubmit}
          resolutionAction={libraryData?.result?.ActionType}
          selectedTicket={selectedTicket}
          ticketActivityType={libraryData?.result?.TicketActivityType}
          ticketPriority={libraryData?.result?.TicketPriority}
          ticketStatus={libraryData?.result?.TicketStatus}
          ticketType={libraryData?.result?.TicketType}
          timelines={timeline}
          TypeData={TypeData}
          accountTypesList={accountTypeItems?.result?.items}
          accountsList={accountItems?.result?.items}
        />
      }
    </>)
}
export default ManagementTicket
